import { Close } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import React from "react";
import { NumericFormat } from "react-number-format";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import convertCurrency from "src/helper/convertCurrency";
export default function CustomerBrand({ setCustomerDetail, customerDetail, index, debtLimit }) {
  const brand = customerDetail?.customerBrands?.[index];
  const onChange = (name, value) => {
    const brands = [...customerDetail?.customerBrands];
    brands[index] = { ...brands[index], [name]: value };
    setCustomerDetail({ ...customerDetail, customerBrands: brands });
  };
  const onRemove = () => {
    setCustomerDetail({ ...customerDetail, customerBrands: customerDetail?.customerBrands?.filter((_, i) => i !== index) });
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
    >
      {index !== 0 && (
        <IconButton
          onClick={onRemove}
          sx={{ background: "var(--grey) !important", width: "18px", height: "18px", m: "0 0 0 auto" }}
        >
          <Close sx={{ width: "16px" }} />
        </IconButton>
      )}
      <SearchFilterComp
        size="large"
        minWidth={0}
        width="100%"
        defaultValue={brand?.brand?._id ?? brand?.brand}
        selectList={[{ id: "brands", title: "Thương hiệu", value: "brands" }]}
        autoComplete={{
          brands: { endpoint: "/api/v1/brands", state: (e) => onChange("brand", e), label: "Thương hiệu", limit: 20, skip: 0, searchField: "name", value: brand?.brand },
          sx: { flex: 1 },
        }}
      />
      <Box
        display="flex"
        gap={2}
      >
        <Box flex={1}>
          <NumericFormat
            fullWidth
            value={brand?.debtLimit ?? 0}
            InputProps={{
              inputProps: { min: 0 },
              startAdornment: (
                <InputAdornment position="start">
                  <Typography> đ {brand?.debtLimit ? "" : 0} </Typography>
                </InputAdornment>
              ),
            }}
            label={
              <span>
                Giới hạn tổng công nợ <span style={{ color: "red", marginLeft: 2 }}> * </span>
              </span>
            }
            error={brand?.debtLimit > debtLimit}
            helperText={brand?.debtLimit > debtLimit ? "Vượt quá giới hạn công nợ" : ""}
            thousandSeparator
            customInput={TextField}
            onValueChange={(values) => onChange("debtLimit", Number(values?.floatValue ?? 0))}
          />
          {brand?.debtLimit > 0 && (
            <Typography
              mt={1}
              sx={{ fontStyle: "italic" }}
              variant="caption"
            >
              <strong> ( {convertCurrency(brand?.debtLimit) ?? "N/A"} đồng) </strong>
            </Typography>
          )}
        </Box>
        <TextField
          sx={{ flex: 1 }}
          label="Chiết khấu (%)"
          type="number"
          value={brand?.discount ?? 0}
          InputProps={{ startAdornment: <InputAdornment position="start"> % </InputAdornment> }}
          inputProps={{ min: 0, max: 100 }}
          onChange={(e) => onChange("discount", Number(e.target.value))}
        />
      </Box>
    </Box>
  );
}
